import Icon from '../Icon';

const CompletedIcon = (props) => {
    return (
        <Icon width='65' height='64' fill='none' {...props}>
            <path
                d='M43.6187 12.9337C40.3431 11.0057 36.5256 9.8999 32.4499 9.8999C20.272 9.8999 10.3999 19.772 10.3999 31.9499C10.3999 44.1278 20.272 53.9999 32.4499 53.9999C44.6278 53.9999 54.4999 44.1278 54.4999 31.9499'
                stroke='#FFFDFB'
                strokeWidth='2.5'
                strokeLinecap='round'
            />
            <path
                d='M41.6927 16.4834C39.0113 14.9052 35.8864 14 32.55 14C22.5813 14 14.5 22.0813 14.5 32.05C14.5 42.0187 22.5813 50.1 32.55 50.1C42.5187 50.1 50.6 42.0187 50.6 32.05'
                stroke='#00D1D2'
                strokeWidth='2.5'
                strokeLinecap='round'
            />
            <path
                d='M21.7148 30.1368L30.6296 39.4669L53.2408 16.2373'
                stroke='#FFFDFB'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default CompletedIcon;
